import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import MoreVert from "@mui/icons-material/MoreVert";
import useActionMenu from "../../actprep-ui/hooks/ui/useActionMenu";

export default function ProgramDayTreeItemLabel({
  programWeek,
  programDayNavItem,
  order,
  handleSwitchDayClick,
  handleRemoveDayClick,
  handleEditDayClick,
}) {
  const programDay = programDayNavItem.data;

  const menuActions = [
    {
      label: "Edit",
      disabled: !programDay,
      onClick: (event) => {
        handleEditDayClick(event, programDay);
      },
    },
    {
      label: "Switch",
      onClick: (event) => {
        handleSwitchDayClick(event, programWeek, programDay, order);
      },
    },
    {
      label: "Remove",
      disabled: !programDay,
      onClick: (event) => {
        handleRemoveDayClick(event, programWeek, programDay, order);
      },
    },
  ];
  const { handleOpen: handleOpenActionMenu, ActionMenu } = useActionMenu({
    actions: menuActions,
  });

  return (
    <>
      <Grid container direction={"row"} alignItems={"center"} maxWidth={300}>
        <Grid size={12}>
          <Stack justifyContent={"space-between"} direction={"row"}>
            <Tooltip
              title={programDayNavItem.label}
              enterDelay={500}
              sx={{ maxWidth: "100%" }}
            >
              <Typography variant="body2" noWrap sx={{ maxWidth: "100%" }}>
                {programDayNavItem.label}
              </Typography>
            </Tooltip>
            <IconButton
              size="small"
              color="primary"
              onClick={handleOpenActionMenu}
            >
              <MoreVert fontSize="small" />
            </IconButton>
          </Stack>
        </Grid>
      </Grid>
      <ActionMenu />
    </>
  );
}
